export default __webpack_public_path__ + "static/media/v-line.a0a59fc0.svg";